import {all, Effect} from 'redux-saga/effects';
import errors from './errors';

export default function* (): IterableIterator<Effect> {
	yield all([errors()]);
}
